export const SET_LAYOUT = 'SET_LAYOUT'
export const SET_CHART = 'SET_CHART'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_PREFECTURES = 'SET_PREFECTURES'
export const LOG_OUT = 'LOG_OUT'
export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'
export const SET_PERMISSION = 'SET_PERMISSION'
export const SET_APP_UPDATE_TIME = 'SET_APP_UPDATE_TIME'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js